export enum BoundingBoxImageClass {
  CompletelyTransparent = "completely-transparent",
  ZeroTransparent = "zero-transparent",
  InnerTransparent = "inner-transparent",
  OuterTransparent = "outer-transparent",
  InnerAndOuterTransparent = "inner-and-outer-transparent",
}
